import $ from 'jquery';
import './typeahead.bundle';
import Bloodhound from './bloodhound';

export default class Typeahead {
	constructor(props) {
		this.props = props;
		this.state = {
			inDocument: false,
			wasDecorated: false,
			value: '',
		};
		this.handleOpen = this.handleOpen.bind(this);
		this.handleAsyncReceive = this.handleAsyncReceive.bind(this);
		this.handleAsyncRequest = this.handleAsyncRequest.bind(this);
	}
	setState(state) {
		const prevState = { ...this.state };
		this.state = {
			...this.state,
			...state,
		};
		// this.updateInternal(this.props, prevState);
	}
	decorate(element) {
		if (this.state.inDocument) {
			throw Error('Component already rendered');
		} else if (element) {
			this.setState({
				wasDecorated: true,
			});

			// Call specific component decorate logic.
			const idAttr = element.getAttribute('id');
			if (idAttr) {
				this.id = idAttr;
			}
			this.setState({
				element,
			});

			this.element = element;


			this.didMount();

			this.setState({
				inDocument: true,
			});
		}
	}
	dispatchEvent(event) {
		$(this.element).trigger(event);
	}
	handleOpen() {
		this.setState({
			isOpen: true,
		});
		const menu = this.instance.menu;
		const datasetsSelector = `${menu.selectors.suggestion}${menu.selectors.selectable}`;

		const firstItemElement = menu.$node.find(datasetsSelector).first();
		let firstItemData = null;
		if (firstItemElement.length > 0) {
			firstItemData = this.instance.menu.getSelectableData(firstItemElement);
		}
		const inputValue = this.instance.input.$input.val();

		const newValue = firstItemData && firstItemData.val === inputValue ? firstItemData.obj.id : '';
		const { value } = this.state;
		const {
			typeaheadTarget,
		} = this.props;
		if (value.toString() !== newValue.toString()) {
			this.setState({
				value: newValue,
			});
			$(typeaheadTarget).val(newValue).trigger('requestValidation');
			this.dispatchEvent({ type: 'change' });
		}
	}
	handleAsyncRequest() {
		this.element.classList.add('is-in-progress');
	}
	handleAsyncReceive() {
		this.element.classList.remove('is-in-progress');
	}
	didMount() {
		const {
			typeaheadOptions,
			typeaheadLabel,
			typeaheadTarget,
			typeaheadUrl,
			typeaheadNotFoundLabel,
			typeaheadPrefetch,
		} = this.props;
		const self = this;
		this.setState({
			value: $(typeaheadTarget).val()
		});
		$(typeaheadLabel)
				.typeahead(
						typeaheadOptions,
						{
							source: new Bloodhound({
								datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
								queryTokenizer: Bloodhound.tokenizers.whitespace,
								remote: {
									url: typeaheadUrl,
									prepare: function (query, settings) {
										return {
											url: settings.url,
											data: {
												q: '%'+query,
											},
											method: 'POST',
										};
									},
									transform: function (response) {
										return response.items;
									},
								},
								...(
										typeaheadPrefetch !== false
								) ? { prefetch: typeaheadUrl } : ''
							}),
							display: 'title',
							limit: Infinity,
							templates: {
								suggestion: function (item) {
									return '<div>' + item.title + '</div>';
								},
								notFound: function (item) {
									return '<div class="tt-suggestion tt-not-found">' + typeaheadNotFoundLabel + '</div>';
								},
							},
						},
				)
				.on('typeahead:select', function (e, item) {
					setTimeout(function() {
						console.log(typeaheadTarget);

						if(typeaheadTarget === '#filterFormContainer_city' || typeaheadTarget === '#filterList_cityTypeahead') {
							$('.js_filter-form-focus-on-result').trigger('click');
						}
					}, 500);
					$(typeaheadTarget)
							.val(item.id)
							.trigger('requestValidation');
					self.dispatchEvent({ type: 'change' });
				})
				.on('typeahead:change', function (e) {
					self.dispatchEvent({ type: 'change' });
				})
				.on('blur', function (e) {
					$(typeaheadTarget)
							.trigger('requestValidation');
				})
				.on('typeahead:asyncrequest', this.handleAsyncRequest)
				.on('typeahead:asynccancel, typeahead:asyncreceive', this.handleAsyncReceive)
				.on('typeahead:open, typeahead:asyncreceive', this.handleOpen);

		this.instance = $(typeaheadLabel)
				.data('tt-typeahead');

		this.instance.input.onSync('queryChanged', this.handleOpen);
	}
}

// eport to window
window.Typeahead = Typeahead;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/Typeahead.js